import React from "react";
import Breadcrumb from './components/Breadcrumb';
import PolicyContent from './components/PolicyContent';
function Policy() {
    
    return (
        <>
            <Breadcrumb />
            <PolicyContent/>
        </>
    )
}
export default Policy;